import React, { useEffect } from 'react';
import { TeacherClassroomStudent } from '../../pages/Teacher/pages/TeacherClassroomStudents';
import Loader from '../Common/Loader';

interface StudentEditSidebarProps {
  student: TeacherClassroomStudent;
  onClose: () => void;
  onAddBookCredit: () => void;
  addBookCreditLoader?: boolean;
  project: string;
}

const StudentEditSidebar: React.FC<StudentEditSidebarProps> = ({
  student,
  onClose,
  onAddBookCredit,
  addBookCreditLoader,
  project,
}) => {
  useEffect(() => {
    console.log(student);
  }, [student]);
  return (
    <div className="absolute right-0 top-0 h-full w-[400px] bg-white shadow-lg z-50 p-4 font-sofiaSans">
      {/* Header with close button */}
      <div className="flex justify-between items-center mb-6">
        <span className="text-2xl font-bold">{student.username}</span>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
          </svg>
        </button>
      </div>

      {/* Book Balance */}
      <div className="mb-4 flex flex-col items-start">
        <h2 className="text-xl font-bold mb-1">Book Balance</h2>
        <span className="text-lg">{student.bookBalance || 0}</span>
      </div>

      {/* Books Completed */}
      <div className="mb-4 flex flex-col items-start">
        <h2 className="text-xl font-bold mb-1">Books Completed</h2>
        <span className="text-lg">{student.booksCompleted || 0}</span>
      </div>

      {/* Pre-order books */}
      <div className="mb-8 flex flex-col items-start">
        <h2 className="text-xl font-bold mb-1">Pre-order books</h2>
        <span className="text-lg">{student.preOrderStudentBookCount || 0}</span>
      </div>

      {/* Add Book Credit Button */}
      <div className="flex">
        <button
          className="flex items-center justify-between text-white py-2 px-6 rounded-full font-semibold text-base bg-storyblueSecondLightText transition"
          disabled={addBookCreditLoader}
          onClick={() => {
            onAddBookCredit();
          }}
        >
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
          </svg>
          <span className="flex justify-center items-center w-full">Add Book Credit</span>
          <Loader loader={addBookCreditLoader}></Loader>
        </button>
      </div>
    </div>
  );
};

export default StudentEditSidebar;
